import React from "react";
import { BookOpenIcon, GiftIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { bonuses } from "../data/bonuses";
import { collectionHighlights } from "../data/page";
import { images, PRICE, TOTAL_VALUE } from "../data/offer";
export function CollectionSection() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-93" data-mp="2z43r3zl4ptoh">
      <div className="mx-auto max-w-5xl" data-id="element-94" data-mp="3msd90qf81xac">
        <SectionHeading title="Your complete diabetic foot assessment collection" subtitle="Everything you'll receive with one purchase." data-id="element-95" data-mp="3qtf919gyqddd" />

        <img src={images.mockup} alt="Complete collection: 6 volumes and 5 bonuses" className="mx-auto mt-8 w-full max-w-2xl" loading="lazy" data-id="element-96" data-mp="3d1s2mgtb3ogv" />

        <div className="mx-auto mt-6 max-w-3xl overflow-hidden rounded-3xl ring-2 ring-navy-900" data-id="element-97" data-mp="9ll6cvd80ti4">
          <ul className="divide-y divide-navy-900/10" data-id="element-98" data-mp="ebryv6ausy5n">
            <li className="flex items-start gap-4 bg-white px-5 py-5 sm:px-7" data-id="element-99" data-mp="edcr2p9p450c">
              <BookOpenIcon className="mt-1 h-6 w-6 shrink-0 text-navy-700" aria-hidden="true" data-id="element-100" data-mp="1tgou76ejp3xj" />
              <div className="flex-1" data-id="element-101" data-mp="1pflbmc544tsm">
                <p className="font-bold text-ink" data-id="element-102" data-mp="1pch2d0csj7v3">DIABETIC FOOT ASSESSMENT BLUEPRINT™ — 6-Volume Collection</p>
                <p className="mt-1 text-sm leading-relaxed text-ink-soft" data-id="element-103" data-mp="1yeylv7129mee">
                  A structured educational reference covering assessment frameworks, sensory and circulatory
                  considerations, skin and wound observations, risk factors, warning signs, and clinical reasoning.
                </p>
              </div>
              <span className="shrink-0 font-bold text-ink-soft line-through" data-id="element-104" data-mp="2m3hu5mk41z6h">$67</span>
            </li>
            {bonuses.map(b => <li key={b.number} className="flex items-start gap-4 bg-white px-5 py-4 sm:px-7" data-id="element-105" data-mp="2h3dic9u5dsml">
                <GiftIcon className="mt-0.5 h-6 w-6 shrink-0 text-alert" aria-hidden="true" data-id="element-106" data-mp="rsmey1ef7luq" />
                <p className="flex-1 font-semibold leading-snug text-ink" data-id="element-107" data-mp="mtjjn8o8stzy">
                  <span className="text-alert" data-id="element-108" data-mp="2muzry9r2sx7m">Bonus #{b.number}</span> — {b.title}
                </p>
                <span className="shrink-0 font-bold text-ink-soft line-through" data-id="element-109" data-mp="2rtb4is8r9ltj">${b.value}</span>
              </li>)}
          </ul>

          <div className="bg-navy-900 px-5 py-8 text-center text-white sm:px-7" data-id="element-110" data-mp="30thfa6d2k7p0">
            <p className="text-sm font-semibold uppercase tracking-wide text-white/70" data-id="element-111" data-mp="30r4n70dlkgy8">Total illustrative reference value</p>
            <p className="font-display text-3xl font-bold text-white/70 line-through" data-id="element-112" data-mp="3ardoutqcyul0">${TOTAL_VALUE} USD</p>
            <p className="mt-4 text-sm font-semibold uppercase tracking-wide text-accent" data-id="element-113" data-mp="3fhu32g206k8f">Your price today</p>
            <p className="font-display text-6xl font-bold text-cta sm:text-7xl" data-id="element-114" data-mp="3khq6oe6sg9ng">
              ${PRICE} <span className="text-3xl" data-id="element-115" data-mp="3ojk144qe4hf6">USD</span>
            </p>
            <p className="mt-2 text-base font-semibold" data-id="element-116" data-mp="3oh7dpc1v5euq">One payment. No monthly subscription.</p>
          </div>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-117" data-mp="1hvb2tzbjnj9l">
          {collectionHighlights.map(h => <li key={h} className="flex gap-2.5 text-base font-medium text-ink" data-id="element-118" data-mp="1cunanabkwwds">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-119" data-mp="18tle5191qyfi" />
              {h}
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-lg text-ink-soft" data-id="element-120" data-mp="20l9lf9cywurh">
          For <strong className="text-ink" data-id="element-121" data-mp="20ndk9cw0f3kw">${PRICE}</strong>, you can bring these diabetic foot assessment educational
          resources together in one organized collection.
        </p>

        <div className="mt-10" data-id="element-122" data-mp="1rr4oc878qn3i">
          <CtaButton label={`Get everything for $${PRICE}`} microcopy="Instant digital access · One-time payment · No monthly fees" data-id="element-123" data-mp="1mtw2nxmvw0xi" />
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-center text-xs text-ink-soft" data-id="element-124" data-mp="2kbcvspyeeerd">
          The reference values are illustrative offer-comparison estimates, not independently verified retail prices or
          claims of previous selling prices.
        </p>
      </div>
    </section>;
}